import type { CSSProperties } from "react";

const ENTER_MAX = 6;
const ENTER_DELAY_MS = 55;

export function cadSlideInProps(index: number): { className?: string; style?: CSSProperties } {
  if (index >= ENTER_MAX) {
    return {};
  }
  return {
    className: "so-slidein",
    style: { animationDelay: `${index * ENTER_DELAY_MS}ms` },
  };
}

export function cadChipInProps(index: number): { className?: string; style?: CSSProperties } {
  if (index >= ENTER_MAX) {
    return {};
  }
  return {
    className: "so-chipin",
    style: { animationDelay: `${index * ENTER_DELAY_MS}ms` },
  };
}
